import gql from 'graphql-tag';

export const  updateChannelGroupRoles = gql`
  mutation updateChannelGroupRoles($groupRole: ChannelGroupRoleInput!) {
    updateChannelGroupRoles(groupRole: $groupRole)
  }
`;
